import { request } from '@/shared/api/request'

export const sendFile = ({ params, data }) => {
	return request({ url: '/assessment/dict/upload', method: 'PUT', params, data })
}
